{
  "error-handler-service": {
    "backend-message": {
      "customer": {
        "blackListed": "Chức năng đặt lịch trực tuyến của bạn tại salon này đã bị chặn. Vui lòng liên hệ với salon để đặt lịch mới",
        "existed": "Tài khoản đã tồn tại",
        "notFound": "Không thể tìm thấy tài khoản",
        "credentialNotMatched": "Mã PIN không hợp lệ. Vui lòng thử lại!",
        "numberOfCredentialFailedMatchesAlreadyExceedMax": "Đã vượt quá số lần thử lại. Vui lòng liên hệ với studio để được hỗ trợ thêm",
        "customerNumberOfCredentialResendExceedMax": "Đã vượt quá số lần thử lại. Vui lòng liên hệ với studio để được hỗ trợ thêm",
        "waitingPeriodBeforeResendNotOverYet": "Hãy kiên nhẫn cho đến khi bạn có thể gửi lại mã PIN sau khoảng một phút"
      },
      "businessObject": {
        "alreadyCheckedIn": "Đã checkin. Vui lòng thử lại sau vài phút",
        "notFound": "Không thể tìm thấy thông tin của tiệm"
      },
      "credit-package-order": {
        "no-capture-payments": "Đơn đặt hàng gói Credit không thành công",
        "order-already-fulfilled": "Đơn đặt hàng gói Credit đã được hoàn tất",
        "order-already-rejected": "Đơn đặt hàng gói Credit đã bị từ chối"
      },
      "email": {
        "exists-confirmed-and-not-changeable": "Không thể thay đổi email đã được xác nhận!"
      },
      "error": {
        "email-exists": "Vì lý do bảo mật, chúng tôi chỉ chấp nhận một email duy nhất được liên kết với một số điện thoại duy nhất. Số điện thoại của bạn đã được liên kết với một email đang được sử dụng. Vui lòng thử đăng nhập bằng email của bạn.",
        "invalid-code": "Mã PIN không hợp lệ. Vui lòng thử lại!",
        "phoneNr-exists": "Vì lý do bảo mật, chúng tôi chỉ chấp nhận một email duy nhất được liên kết với một số điện thoại duy nhất. Email của bạn đã được liên kết với một số điện thoại đang được sử dụng. Vui lòng thử đăng nhập bằng số điện thoại của bạn."
      },
      "review": {
        "notFound": "Đường link không hợp lệ hoặc đã hết hạn"
      },
      "startTime": {
        "invalid": "Thời gian đã chọn không còn nữa. Vui lòng chọn thời gian khác!"
      },
      "Unauthorized": "Vui lòng đăng nhập lại bằng email và mật khẩu chính xác!",
      "user-challenge": {
        "too-much-requests": "Bạn đã gửi yêu cầu quá liên tục. Vui lòng thử lại sau vài giây"
      },
      "appointment duration is too long, max 4 hours": "Thời lượng tối đa là 4 giờ. Vui lòng thay đổi các dịch vụ đã chọn của bạn.",
      "No available slot at desired start time": "Thời gian đã chọn không còn nữa. Vui lòng chọn thời gian khác!",
      "confirmed appointment already exists at same time": "Bạn đã đặt một cuộc hẹn cho cùng ngày giờ đã chọn",
      "customer already has maximum number of confirmed appointments": "Đã đạt đến số lượng lịch hẹn tối đa với salon này. Vui lòng liên hệ với salon để đặt lịch hẹn mới"
    },
    "text": {
      "server-connection-error": "Không có kết nối với máy chủ",
      "general-error": "Rất tiếc! Đã có lỗi xảy ra. Vui lòng thử lại sau."
    }
  }
}
